import get from "lodash/get";
import React from "react";

export class JsonTextField extends React.PureComponent {
  static defaultProps = {
    addLabel: true,
  };

  render() {
    const { record, source } = this.props;
    const value = get(record, source);
    const text = JSON.stringify(value, null, 2);
    return <pre>{text}</pre>;
  }
}
